import React, { Suspense } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';

export default function withLoadableComponent<T>(
  LoadableComponent: React.ComponentType<T>,
  fallback = null
) {
  const NewLoadable: React.FC<T> = props => {
    const isMounted = useIsMounted();

    return !isMounted ? null : (
      <ErrorBoundary debugComponent="withLoadableComponent">
        <Suspense fallback={fallback}>
          <LoadableComponent
            {...props}
            key={`withLoadableComponent${LoadableComponent.displayName}`}
          />
        </Suspense>
      </ErrorBoundary>
    );
  };
  NewLoadable.displayName = `Loadable(${LoadableComponent.displayName})`;
  return NewLoadable;
}
